/**
 * Cost Maintenance Action Types
 *
 * @author ysum5308
 */
export const VALIDATE_ITEMS_BY_SUPCS = 'VALIDATE_ITEMS_BY_SUPCS';
export const RECEIVE_ITEM_VALIDATION_RESPONSE = 'RECEIVE_ITEM_VALIDATION_RESPONSE';
export const RESET_ITEM_VALIDATION_RESPONSE = 'RESET_ITEM_VALIDATION_RESPONSE';

export const REQUEST_COST_DATA = 'REQUEST_COST_DATA';
export const RECEIVE_COST_DATA = 'RECEIVE_COST_DATA';
export const SUBMIT_GENERATE_COST_REPORTS = 'SUBMIT_GENERATE_COST_REPORTS';

export const REQUEST_ADHOC_COST_FILE_IMPORT = 'REQUEST_ADHOC_COST_FILE_IMPORT';
export const REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT = 'REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT';

export const RECEIVE_ADHOC_COST_FILE_IMPORT_RESPONSE = 'RECEIVE_ADHOC_COST_FILE_IMPORT_RESPONSE';
export const RECEIVE_MULTIPLE_ADHOC_COST_FILE_IMPORT_RESPONSE = 'RECEIVE_MULTIPLE_ADHOC_COST_FILE_IMPORT_RESPONSE';

export const RESET_ADHOC_COST_DATA = 'RESET_ADHOC_COST_DATA';

export const REQUEST_BUSINESS_CENTER_DETAILS = 'REQUEST_BUSINESS_CENTER_DETAILS';
export const RECEIVE_BUSINESS_CENTER_DETAILS = 'RECEIVE_BUSINESS_CENTER_DETAILS';
export const RESET_BUSINESS_CENTER_DETAILS = 'RESET_BUSINESS_CENTER_DETAILS';

export const REQUEST_PRICE_RECORD_TYPES = 'REQUEST_PRICE_RECORD_TYPES';
export const RECEIVE_PRICE_RECORD_TYPES = 'RECEIVE_PRICE_RECORD_TYPES';
export const RESET_PRICE_RECORD_TYPES = 'RESET_PRICE_RECORD_TYPES';

export const REQUEST_MODULE_PRICE_IMPORT = 'REQUEST_MODULE_PRICE_IMPORT';
export const RECEIVE_MODULE_PRICE_IMPORT = 'RECEIVE_MODULE_PRICE_IMPORT';

export const REQUEST_ALL_MODULES = 'REQUEST_ALL_MODULES';
export const RECEIVE_ALL_MODULES = 'RECEIVE_ALL_MODULES';

export const REQUEST_MODULE_PRICE_EXPORT = 'REQUEST_MODULE_PRICE_EXPORT';
export const RECEIVE_MODULE_PRICE_EXPORT = 'RECEIVE_MODULE_PRICE_EXPORT';

export const REQUEST_ITEM_PRICE = 'REQUEST_ITEM_PRICE';
export const RECEIVE_ITEM_PRICE = 'RECEIVE_ITEM_PRICE';

export const UPDATE_ITEM_PRICE_FILTER = 'UPDATE_ITEM_PRICE_FILTER';
export const CLEAR_ITEM_PRICE_FILTER = 'CLEAR_ITEM_PRICE_FILTER';
export const SELECT_MODULE_IN_PRICE_EXPORT = 'SELECT_MODULE_IN_PRICE_EXPORT';

export const CREATE_MODULE_GROUP = 'REQUEST_CREATE_MODULE_GROUP';
export const RECEIVE_CREATE_MODULE_GROUP = 'RECEIVE_CREATE_MODULE_GROUP';

export const REQUEST_ALL_COMMODITIES = 'REQUEST_ALL_COMMODITIES';
export const RECEIVE_ALL_COMMODITIES = 'RECEIVE_ALL_COMMODITIES';

export const CREATE_COMMODITY_GROUP = 'REQUEST_CREATE_COMMODITY_GROUP';
export const RECEIVE_CREATE_COMMODITY_GROUP = 'RECEIVE_CREATE_COMMODITY_GROUP';

export const REQUEST_COMMODITY_DETAILS = 'REQUEST_COMMODITY_DETAILS';
export const RECEIVE_COMMODITY_DETAILS = 'RECEIVE_COMMODITY_DETAILS';

export const REQUEST_MODULE_GROUPS_ASSOCIATIONS = 'REQUEST_MODULE_GROUPS_ASSOCIATIONS';
export const RECEIVE_MODULE_GROUPS_ASSOCIATIONS = 'RECEIVE_MODULE_GROUPS_ASSOCIATIONS';
export const UPDATE_MODULE_VIEW_FILTER = 'UPDATE_MODULE_VIEW_FILTER';
export const CLEAR_MODULE_VIEW_FILTER = 'CLEAR_MODULE_VIEW_FILTER';

export const REQUEST_MODULE_GROUP_UPDATE = 'REQUEST_MODULE_GROUP_UPDATE';
export const RECEIVE_MODULE_GROUP_UPDATE = 'RECEIVE_MODULE_GROUP_UPDATE';

export const REQUEST_MODULE_GROUP_DELETE = 'REQUEST_MODULE_GROUP_DELETE';
export const RECEIVE_MODULE_GROUP_DELETE = 'RECEIVE_MODULE_GROUP_DELETE';

export const REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT = 'REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT';
export const RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT = 'RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT';

export const REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT = 'REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT';
export const RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT = 'RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT';

export const REQUEST_ALL_LOADING_AREAS = 'REQUEST_ALL_LOADING_AREAS';
export const RECEIVE_ALL_LOADING_AREAS = 'RECEIVE_ALL_LOADING_AREAS';

export const REQUEST_COMMODITY_GROUP_UPDATE = 'REQUEST_COMMODITY_GROUP_UPDATE';
export const RECEIVE_COMMODITY_GROUP_UPDATE = 'RECEIVE_COMMODITY_GROUP_UPDATE';

export const REQUEST_COMMODITY_GROUP_DELETE = 'REQUEST_COMMODITY_GROUP_DELETE';
export const RECEIVE_COMMODITY_GROUP_DELETE = 'RECEIVE_COMMODITY_GROUP_DELETE';

export const REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT = 'REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT';
export const RECEIVE_COMMODITY_GROUP_ITEM_ASSIGNMENT = 'RECEIVE_COMMODITY_GROUP_ITEM_ASSIGNMENT';

export const UPDATE_COMMODITY_VIEW_FILTER = 'UPDATE_COMMODITY_VIEW_FILTER';
export const CLEAR_COMMODITY_VIEW_FILTER = 'CLEAR_COMMODITY_VIEW_FILTER';

export const REQUEST_ALL_PRICE_MODULE_ITEMS = 'REQUEST_ALL_PRICE_MODULE_ITEMS';
export const RECEIVE_ALL_PRICE_MODULE_ITEMS = 'RECEIVE_ALL_PRICE_MODULE_ITEMS';

export const REQUEST_LOADING_AREA_CREATE = 'REQUEST_LOADING_AREA_CREATE';
export const RECEIVE_LOADING_AREA_CREATE = 'RECEIVE_LOADING_AREA_CREATE';

export const REQUEST_LOADING_AREA_DETAILS = 'REQUEST_LOADING_AREA_DETAILS';
export const RECEIVE_LOADING_AREA_DETAILS = 'RECEIVE_LOADING_AREA_DETAILS';

export const REQUEST_LOADING_AREA_DELETE = 'REQUEST_LOADING_AREA_DELETE';
export const RECEIVE_LOADING_AREA_DELETE = 'RECEIVE_LOADING_AREA_DELETE';

export const REQUEST_LOADING_AREA_UPDATE = 'REQUEST_LOADING_AREA_UPDATE';
export const RECEIVE_LOADING_AREA_UPDATE = 'RECEIVE_LOADING_AREA_UPDATE';

export const REQUEST_MODULE_GROUP_REACTIVATE = 'REQUEST_MODULE_GROUP_REACTIVATE';
export const RECEIVE_MODULE_GROUP_REACTIVATE = 'RECEIVE_MODULE_GROUP_REACTIVATE';

export const REQUEST_COMMODITY_GROUP_REACTIVATE = 'REQUEST_COMMODITY_GROUP_REACTIVATE';
export const RECEIVE_COMMODITY_GROUP_REACTIVATE = 'RECEIVE_COMMODITY_GROUP_REACTIVATE';

export const REQUEST_LOADING_AREA_REACTIVATE = 'REQUEST_LOADING_AREA_REACTIVATE';
export const RECEIVE_LOADING_AREA_REACTIVATE = 'RECEIVE_LOADING_AREA_REACTIVATE';

export const REQUEST_UPDATE_MODULE_PRICES = 'REQUEST_UPDATE_MODULE_PRICES';
export const RECEIVE_UPDATE_MODULE_PRICES = 'RECEIVE_UPDATE_MODULE_PRICES';

export const validateItemsBySupcs = (data) => (
  {
    type: VALIDATE_ITEMS_BY_SUPCS,
    data
  });

export const receiveItemValidationResponse = (data) => (
  {
    type: RECEIVE_ITEM_VALIDATION_RESPONSE,
    data
  });

export const resetItemValidationResponse = () => (
  { type: RESET_ITEM_VALIDATION_RESPONSE });

export const requestCostData = (data) => (
  {
    type: REQUEST_COST_DATA,
    data
  });

export const receiveCostData = (data) => (
  {
    type: RECEIVE_COST_DATA,
    data
  });

export const requestAdhocCostFileImport = (data) => (
  {
    type: REQUEST_ADHOC_COST_FILE_IMPORT,
    data
  }
);

export const resetAdhocCostData = () => (
  { type: RESET_ADHOC_COST_DATA });

export const requestBusinessCenterDetails = (data) => (
  {
    type: REQUEST_BUSINESS_CENTER_DETAILS,
    data
  });

export const receiveBusinessCenterDetails = (data) => (
  {
    type: RECEIVE_BUSINESS_CENTER_DETAILS,
    data
  });

export const resetBusinessCenterDetails = () => (
  { type: RESET_BUSINESS_CENTER_DETAILS });

export const requestPriceRecordTypes = (data) => (
  {
    type: REQUEST_PRICE_RECORD_TYPES,
    data
  });

export const receivePriceRecordTypes = (data) => (
  {
    type: RECEIVE_PRICE_RECORD_TYPES,
    data
  });

export const resetPriceRecordTypes = () => (
  { type: RESET_PRICE_RECORD_TYPES });

export const submitGenerateCostReports = (data) => (
  {
    type: SUBMIT_GENERATE_COST_REPORTS,
    data
  });

export const requestMultipleAdhocCostFileImport = (data) => (
  {
    type: REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT,
    data
  });

export const receiveAdhocCostFileImportResponse = (data) => (
  {
    type: RECEIVE_ADHOC_COST_FILE_IMPORT_RESPONSE,
    data
  });

export const receiveMultipleAdhocCostFileImportResponse = (data) => (
  {
    type: RECEIVE_MULTIPLE_ADHOC_COST_FILE_IMPORT_RESPONSE,
    data
  });

export const requestModulePriceImport = (data) => ({ type: REQUEST_MODULE_PRICE_IMPORT, data });
export const receiveModulePriceImport = (data) => ({ type: RECEIVE_MODULE_PRICE_IMPORT, data });

export const requestAllModules = () => ({ type: REQUEST_ALL_MODULES });
export const receiveAllModules = (data) => ({ type: RECEIVE_ALL_MODULES, data });

export const requestModulePriceExport = (data) => ({ type: REQUEST_MODULE_PRICE_EXPORT, data });
export const receiveModulePriceExport = () => ({ type: RECEIVE_MODULE_PRICE_EXPORT });

export const requestItemPrice = (data) => ({ type: REQUEST_ITEM_PRICE, data });
export const receiveItemPrice = (data) => ({ type: RECEIVE_ITEM_PRICE, data });

export const updateItemPriceFilter = (key, value) => ({
  type: UPDATE_ITEM_PRICE_FILTER,
  data: {
    key, value
  }
});

export const clearItemPriceFilter = () => ({
  type: CLEAR_ITEM_PRICE_FILTER
});

export const createModuleGroup = (data) => ({ type: CREATE_MODULE_GROUP, data });
export const receiveCreateModuleGroup = (data) => ({ type: RECEIVE_CREATE_MODULE_GROUP, data });

export const requestAllCommodities = () => ({ type: REQUEST_ALL_COMMODITIES });
export const receiveAllCommodities = (data) => ({ type: RECEIVE_ALL_COMMODITIES, data });

export const createCommodityGroup = (data) => ({ type: CREATE_COMMODITY_GROUP, data });
export const receiveCreateCommodityGroup = (data) => ({ type: RECEIVE_CREATE_COMMODITY_GROUP, data });

export const requestCommodityDetails = (data) => ({ type: REQUEST_COMMODITY_DETAILS, data });
export const receiveCommodityDetails = (data) => ({ type: RECEIVE_COMMODITY_DETAILS, data });

export const requestModuleGroupsAssociations = (data) => ({ type: REQUEST_MODULE_GROUPS_ASSOCIATIONS, data });
export const receiveModuleGroupsAssociations = (data) => ({ type: RECEIVE_MODULE_GROUPS_ASSOCIATIONS, data });

export const updateModuleViewFilter = (key, value) => ({
  type: UPDATE_MODULE_VIEW_FILTER,
  data: {
    key, value
  }
});

export const clearModuleViewFilter = () => ({
  type: CLEAR_MODULE_VIEW_FILTER
});

export const requestDeleteModuleGroup = (data) => ({ type: REQUEST_MODULE_GROUP_DELETE, data });
export const receiveDeleteModuleGroup = (data) => ({ type: RECEIVE_MODULE_GROUP_DELETE, data });

export const requestModuleGroupUpdate = (moduleId, data) => ({ type: REQUEST_MODULE_GROUP_UPDATE, data, moduleId });
export const receiveModuleGroupUpdate = (data) => ({ type: RECEIVE_MODULE_GROUP_UPDATE, data });

export const requestModuleGroupCommodityAssignment = (moduleId, data) => ({ type: REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT, moduleId, data });
export const receiveModuleGroupCommodityAssignment = (data) => ({ type: RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT, data });

export const requestModuleGroupLoadingAreaAssignment = (moduleId, data) => ({ type: REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT, moduleId, data });
export const receiveModuleGroupLoadingAreaAssignment = (data) => ({ type: RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT, data });

export const requestAllLoadingAreas = () => ({ type: REQUEST_ALL_LOADING_AREAS });
export const receiveAllLoadingAreas = (data) => ({ type: RECEIVE_ALL_LOADING_AREAS, data });

export const requestCommodityGroupUpdate = (comcodeId, data) => ({ type: REQUEST_COMMODITY_GROUP_UPDATE, data, comcodeId });
export const receiveCommodityGroupUpdate = (data) => ({ type: RECEIVE_COMMODITY_GROUP_UPDATE, data });

export const requestCommodityGroupDelete = (comcodeId) => ({ type: REQUEST_COMMODITY_GROUP_DELETE, comcodeId });
export const receiveCommodityGroupDelete = (comcodeId) => ({ type: RECEIVE_COMMODITY_GROUP_DELETE, comcodeId });

export const requestCommodityGroupItemAssignment = (comcodeId, data) => ({ type: REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT, comcodeId, data });
export const receiveCommodityGroupItemAssignment = (data) => ({ type: RECEIVE_COMMODITY_GROUP_ITEM_ASSIGNMENT, data });

export const requestAllPriceModuleItems = (comcodeId, data) => ({ type: REQUEST_ALL_PRICE_MODULE_ITEMS, comcodeId, data });
export const receiveAllPriceModuleItems = (data) => ({ type: RECEIVE_ALL_PRICE_MODULE_ITEMS, data });

export const requestLoadingAreaDetails = (data) => ({ type: REQUEST_LOADING_AREA_DETAILS, data });
export const receiveLoadingAreaDetails = (data) => ({ type: RECEIVE_LOADING_AREA_DETAILS, data });

export const requestLoadingAreaCreate = (data) => ({ type: REQUEST_LOADING_AREA_CREATE, data });
export const receiveLoadingAreaCreate = (data) => ({ type: RECEIVE_LOADING_AREA_CREATE, data });

export const requestLoadingAreaUpdate = (loadingAreaId, data) => ({ type: REQUEST_LOADING_AREA_UPDATE, data, loadingAreaId });
export const receiveLoadingAreaUpdate = (data) => ({ type: RECEIVE_LOADING_AREA_UPDATE, data });

export const requestLoadingAreaDelete = (loadingAreaId) => ({ type: REQUEST_LOADING_AREA_DELETE, loadingAreaId });
export const receiveLoadingAreaDelete = (loadingAreaId) => ({ type: RECEIVE_LOADING_AREA_DELETE, loadingAreaId });

export const requestReactivateModuleGroup = (data) => ({ type: REQUEST_MODULE_GROUP_REACTIVATE, data });
export const receiveReactivateModuleGroup = (data) => ({ type: RECEIVE_MODULE_GROUP_REACTIVATE, data });

export const requestReactivateCommodityGroup = (data) => ({ type: REQUEST_COMMODITY_GROUP_REACTIVATE, data });
export const receiveReactivateCommodityGroup = (data) => ({ type: RECEIVE_COMMODITY_GROUP_REACTIVATE, data });

export const requestReactivateLoadingArea = (data) => ({ type: REQUEST_LOADING_AREA_REACTIVATE, data });
export const receiveReactivateLoadingArea = (data) => ({ type: RECEIVE_LOADING_AREA_REACTIVATE, data });

export const requestUpdateModulePrices = (data) => ({ type: REQUEST_UPDATE_MODULE_PRICES, data });
export const receiveUpdateModulePrices = (data) => ({ type: RECEIVE_UPDATE_MODULE_PRICES, data });
